<div class="card">
  <div class="card-body text-center">
    <div class="row">
      <div class="col-12 align-self-center">
        <h4>{{ 'pageNotFoundPage.title' | translate }} </h4>
        <p>{{ 'pageNotFoundPage.message' | translate }} </p>
      </div>
    </div>
  </div>
</div>